<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4">
				<div class="row d-flex justify-content-between">
					<div class="col-md-3">
						<h1 class="h3 mb-0 text-gray-800">
							Entrega {{ dados.id }}
						</h1>
					</div>
					<div class="col-md-9 noprint d-flex justify-content-end">
                        <button
                            class="btn mr-1 btn-success"
                            @click="finalizar()">
                            <i class="fas mr-2 fa-check"></i>
                            <span v-if="!dados.finalizado_at">Finalizar</span>
                            <span v-else>Não Finalizar</span>
                        </button>
						<button
							class="btn btn-success mr-1"
							@click="gerarPdf">
							<i class="fas fa-file-pdf mr-2"></i>
							Gerar PDF
						</button>
						<button
							class="btn btn-primary mr-1"
							@click="update">
							<i class="fas fa-edit"></i>
						</button>
						<button
							class="btn btn-danger mr-1"
							@click="confirmDestroy()">
							<i class="fas fa-trash"></i>
						</button>
						<button
					        @click="$router.go(-1)"
					        class="btn btn-secondary">
				           	Voltar
				        </button>
				    </div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<!-- Informações -->
					<entrega-info
						:dados="dados">
					</entrega-info>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<!-- Destinos -->
		    		<entrega-destino-card
		    			:key="entregaDestinoTableKey"
		    			@reload="getDados">
		    		</entrega-destino-card>
				</div>
			</div>
		</div>
		<!-- Editar Pedido -->
		<entrega-update
			@reload="getDados">
		</entrega-update>
		<!-- Confirmação para excluir -->
        <bsh-confirm
        	modal_id="confirm_destroy_entrega"
        	:dado_id="$route.params.id"
        	title="Deseja realmente remover esta entrega?"
        	btn="Excluir"
        	btnStyle="btn-danger"
        	method="delete"
        	:rota="$url+'/api/adm/entregas/destroy/'"
        	@reload="back()">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dados: [],
                entregaDestinoTableKey: 1
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/entregas/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data
                    this.entregaDestinoTableKey++
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
		    gerarPdf(){
				var link = document.createElement("a");
                link.setAttribute('download', null);
                link.href = this.$url+'/api/adm/entregas/pdf/'+this.$route.params.id;
                document.body.appendChild(link);
                link.click();
                link.remove();
			},
            finalizar(){
                var config = {
					position: 'bottom-right',
				};
				axios.put(this.$url+'/api/adm/entregas/finalizar/'+this.$route.params.id)
	            .then(response => {
	            	this.$bshMessage.show(response.data.message, response.data.type, config)
	            	this.getDados();
	            })
	            .catch(error => {
	            	this.$bshMessage.show(error.response.data.message, 'error')
	            });
            },
			update(){
				$('#update_entrega').modal('show');
			},
			confirmDestroy(){
				$('#confirm_destroy_entrega').modal('show');
			},
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>
